import { Rating } from '@/feature/chatbot/api.types';
import { useTexts, useTranslation } from '@/feature/lang';

interface RatingOption {
  rating: Rating;
  icon: string;
  text?: string;
}

export const useRatingOptions = (): RatingOption[] => {
  const texts = useTexts().component.chatbot;
  const { translate } = useTranslation();
  return [
    {
      rating: 'good',
      icon: 'sentiment_satisfied',
      text: translate(texts.rating.values.good),
    },
    {
      rating: 'neutral',
      icon: 'sentiment_neutral',
      text: translate(texts.rating.values.neutral),
    },
    {
      rating: 'bad',
      icon: 'sentiment_dissatisfied',
      text: translate(texts.rating.values.bad),
    },
  ];
};
